import VideoStreamAPI from './video-stream-api';

export default VideoStreamAPI;
